// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"f944652c","453":"5706c150"}[chunkId] + ".chunk.js";
};